import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

const OrderOutlined = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: BusinessIconImageProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'path',
        {
          d: 'M19 5.5H5C3.89543 5.5 3 6.39543 3 7.5V16.5C3 17.6046 3.89543 18.5 5 18.5H19C20.1046 18.5 21 17.6046 21 16.5V7.5C21 6.39543 20.1046 5.5 19 5.5Z',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.5",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M3 9.5H21',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.5",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M15.5 15H18',
          stroke: 'currentColor',
          "stroke-width": strokeWidth ?? "1.5",
          "stroke-linecap": 'round',
          "stroke-linejoin": 'round',
        },
      ),
    ],
  );

export default OrderOutlined;
